import { render, staticRenderFns } from "./mainBodyGoodsList.vue?vue&type=template&id=f4195b5c&scoped=true&"
import script from "./mainBodyGoodsList.vue?vue&type=script&lang=js&"
export * from "./mainBodyGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./mainBodyGoodsList.vue?vue&type=style&index=0&id=f4195b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4195b5c",
  null
  
)

export default component.exports